import noSales from "assets/images/logos/noSales.png";
import { Grid, Typography } from "@mui/material";
import theme from "assets/theme";
import FaiBox from "MuiComponents/FaiBox";
import FaiTypography from "MuiComponents/FaiTypography";
import FaiButton from "MuiComponents/FaiButton";
import PageHeader from "screens/OnBoarding/components/PageHeader";

function NoListing({ onAddNew = () => {} }) {
	const { palette, borders } = theme;

	return (
		<FaiBox
			bgColor={palette.white.main}
			className={"container coupon-form-content"}
			mt={"40px"}
			borderRadius={borders.borderRadius.md}
			verticalAlign="middle"
		>
			<Grid container spacing={8} style={{ alignItems: "center" }}>
				<Grid item xs={12} sm={6}>
					<FaiBox className="flex flex-col gap-5">
						<PageHeader
							title="No Active Sales"
							content="It looks like you don't have any active sales at the moment. Add a
							sale to start offering discounts to your customers."
						/>
						<FaiBox>
							<FaiButton
								color="primary"
								variant={"contained"}
								fullWidth
								onClick={onAddNew}
							>
								Add new Sale
							</FaiButton>
						</FaiBox>
					</FaiBox>
				</Grid>

				<Grid item xs={12} sm={6} className="flex justify-center">
					<FaiBox
						component={"img"}
						width="100% !important"
						height="auto !important"
						src={noSales}
						style={{ maxHeight: "300px", maxWidth: "300px" }}
						className="p-5"
					/>
				</Grid>
			</Grid>
		</FaiBox>
	);
}
export default NoListing;

// const NoListings = () => {
//   return (
//     <CustomBox>
//       <Container sx={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//         <Grid container spacing={3} justifyContent="center" alignItems="center" textAlign="center">

//           <Grid item xs={12} md={6}>
//             <Typography variant="h5" gutterBottom>
//               No Active Sales
//             </Typography>
//             <Typography variant="body1" color="textSecondary" paragraph>
//                 It looks like you don't have any active sales at the moment. Add a sale to start offering discounts to your customers.
//             </Typography>

//             <Box sx={{ display: 'flex', justifyContent: 'center' }}>
//               <FaiButton
//                 color="primary"
//                 variant="contained"
//                 sx={{ mr: '10px', width: "100%" }}
//               >
//                 Add new Sale
//               </FaiButton>
//             </Box>
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <Box
//               component="img"
//               sx={{
//                 width: {
//                   xs: '75%',
//                   sm: '60%',
//                   md: '50%',
//                   lg: '50%',
//                   xl: '60%',
//                 },
//                 height: 'auto',
//                 marginBottom: 3,
//               }}
//               alt="No Sales"
//               src={noSales}
//             />
//           </Grid>

//         </Grid>
//       </Container>
//     </CustomBox>
//   );
// };

// export default NoListings;
